import React from "react";
import { Select } from "antd";
import { Translate } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { EU_LANGUAGES } from "../../i18n/languages";

interface LanguageSwitcherProps {
  size?: "small" | "middle" | "large";
  bordered?: boolean;
  style?: React.CSSProperties;
}

/**
 * Przełącznik języka (24 języki UE). Wybór jest zapamiętywany w localStorage
 * (klucz "appLanguage") i automatycznie wykrywany z przeglądarki przy pierwszym wejściu.
 */
export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  size = "middle",
  bordered = true,
  style,
}) => {
  const { i18n, t } = useTranslation();

  const current = (i18n.resolvedLanguage || i18n.language || "pl").split("-")[0];

  return (
    <Select
      size={size}
      variant={bordered ? "outlined" : "borderless"}
      value={current}
      onChange={(lng) => i18n.changeLanguage(lng)}
      suffixIcon={<Translate size={16} />}
      aria-label={t("language.select")}
      style={{ minWidth: 140, ...style }}
      popupMatchSelectWidth={false}
      showSearch
      optionFilterProp="label"
      options={EU_LANGUAGES.map((l) => ({ value: l.code, label: l.label }))}
    />
  );
};

export default LanguageSwitcher;
